<template>
  <CDropdown
    v-if="isTenantAdmin"
    placement="bottom-end"
    :caret="false"
    in-nav
    class="c-header-nav-items app-switcher"
    add-menu-classes="app-switcher-menu pt-0"
  >
    <template #toggler>
      <CHeaderNavLink>
        <CIcon name="cil-applications" size="lg" />
      </CHeaderNavLink>
    </template>
    <CDropdownHeader tag="div" class="text-center bg-light">
      <strong>Switch App</strong>
    </CDropdownHeader>
    <CDropdownItem class="app-item app-item-current" disabled>
      <div class="app-item-content">
        <div class="app-icon" style="background: #4f5d73;">
          <CIcon name="cil-speedometer" class="text-white" />
        </div>
        <div class="app-info">
          <strong>Admin</strong>
          <small class="text-muted d-block">Finance, HR & Payroll</small>
        </div>
        <CBadge color="success" shape="pill" class="ml-auto">Current</CBadge>
      </div>
    </CDropdownItem>
    <CDropdownItem class="app-item" @click="navigateToApp('rental')">
      <div class="app-item-content">
        <div class="app-icon" style="background: #2eb85c;">
          <CIcon name="cil-house" class="text-white" />
        </div>
        <div class="app-info">
          <strong>Rental</strong>
          <small class="text-muted d-block">Properties & Reservations</small>
        </div>
        <CIcon name="cil-external-link" size="sm" class="ml-auto text-muted" />
      </div>
    </CDropdownItem>
    <CDropdownItem class="app-item" @click="navigateToApp('services')">
      <div class="app-item-content">
        <div class="app-icon" style="background: #3399ff;">
          <CIcon name="cil-calendar" class="text-white" />
        </div>
        <div class="app-info">
          <strong>Services</strong>
          <small class="text-muted d-block">Bookings & Scheduling</small>
        </div>
        <CIcon name="cil-external-link" size="sm" class="ml-auto text-muted" />
      </div>
    </CDropdownItem>
  </CDropdown>
</template>

<script>
export default {
  name: "TheHeaderAppSwitcher",
  computed: {
    isTenantAdmin() {
      try {
        return window.auth.getRole() === "TenantAdmin";
      } catch (e) {
        return false;
      }
    },
  },
  methods: {
    navigateToApp(app) {
      const token = window.auth.token;
      const business = window.auth.getLocalBusiness();
      const businessId = business ? business.id : "";

      let baseUrl = "";
      if (app === "rental") {
        baseUrl = window.config.RENTAL_APP_URL || "http://localhost:8082";
      } else if (app === "services") {
        baseUrl = window.config.SERVICES_APP_URL || "http://localhost:8083";
      }

      if (!baseUrl) return;

      const url = `${baseUrl}?token=${encodeURIComponent(token)}&businessId=${encodeURIComponent(businessId)}`;
      window.open(url, "_blank");
    },
  },
};
</script>

<style scoped>
.app-switcher-menu {
  min-width: 280px;
}

.app-item {
  padding: 0 !important;
  cursor: pointer;
}

.app-item:hover {
  background-color: #f0f4f7;
}

.app-item-current {
  opacity: 0.85;
  cursor: default !important;
}

.app-item-content {
  display: flex;
  align-items: center;
  padding: 0.65rem 1rem;
  width: 100%;
  gap: 0.75rem;
}

.app-icon {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.app-info {
  flex: 1;
  min-width: 0;
}

.app-info strong {
  font-size: 0.875rem;
  display: block;
  line-height: 1.2;
}

.app-info small {
  font-size: 0.75rem;
  line-height: 1.2;
}
</style>
